/* PlanSelect.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _10 = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const _9 = "._1bsb1osq{width:100%}";
const _8 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _7 = "._18u01wug{margin-left:auto}";
const _6 = "._otyr1wug{margin-bottom:auto}";
const _5 = "._2hwx1wug{margin-right:auto}";
const _4 = "._19pk1wug{margin-top:auto}";
const _3 = "._2lx21bp4{flex-direction:column}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import Select from '@atlaskit/select';
import Tooltip from '@atlaskit/tooltip';
import { Link } from '@atlassian/mpac-primitives';
import { TooltipDialog } from '@atlassian/mpac-ui';
import capitalize from 'lodash/capitalize';
import { useEffect } from 'react';
import * as React from 'react';
import { TEST_IDS } from '../../testIds';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _2 = "._4cvr1h6o{align-items:center}";
const _ = "._1e0c1txw{display:flex}";
const Flex = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Flex.displayName = 'Flex';
}
const FlexColumn = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FlexColumn.displayName = 'FlexColumn';
}
const TooltipIconContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TooltipIconContainer.displayName = 'TooltipIconContainer';
}
const SelectContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _6, _7, _8, _, _3, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp1b66 _1e0c1txw _2lx21bp4 _1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SelectContainer.displayName = 'SelectContainer';
}
const StyledLink = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = Link,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pk1b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  StyledLink.displayName = 'StyledLink';
}
function PlanSelect(props) {
  useEffect(() => {
    // This is required because after opening site-selector, the tooltip was automatically getting focused without hovering and inner contents were displayed.
    setTimeout(() => {
      const activeElement = document.activeElement;
      if (activeElement) {
        activeElement.blur();
      }
    });
  }, []);
  const selectOptions = props.editionTypeList.map(type => ({
    label: capitalize(type),
    value: type
  }));
  const defaultOption = selectOptions.find(_ref6 => {
    let {
      value
    } = _ref6;
    return value === props.selectedPlan;
  });
  const TooltipContent = () => /*#__PURE__*/_jsxs(FlexColumn, {
    children: [/*#__PURE__*/_jsx("span", {
      children: "This app offers two different plans - Standard and Advanced. You can start a free trial of either plan, and change your plan anytime during or after the trial."
    }), /*#__PURE__*/_jsx(StyledLink, {
      size: "small",
      href: props.appPricingDetailsLink,
      children: "Explore pricing plans"
    })]
  });
  return /*#__PURE__*/_jsxs(SelectContainer, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      children: ["Plan", /*#__PURE__*/_jsx(Tooltip, {
        component: TooltipDialog,
        position: "bottom-start",
        content: TooltipContent,
        children: /*#__PURE__*/_jsx(TooltipIconContainer, {
          tabIndex: 0,
          children: /*#__PURE__*/_jsx(EditorPanelIcon, {
            label: "Learn more about app plans",
            size: "medium",
            testId: TEST_IDS.PLAN_SELECTOR_TOOLTIP
          })
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      "data-testId": TEST_IDS.PLAN_SELECTOR,
      children: /*#__PURE__*/_jsx(Select, {
        defaultValue: defaultOption,
        options: selectOptions,
        isOptionSelected: (option, selected) => selected[0] === option,
        onChange: e => e && props.setSelectedPlan(e.value),
        placeholder: "Choose a plan"
      })
    })]
  });
}
export default PlanSelect;